import React from 'react';
import { Flame, Sun, Snowflake } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

const TEMPERATURE_CONFIG = {
  HOT: { icon: Flame, className: 'text-red-400' },
  WARM: { icon: Sun, className: 'text-amber-400' },
  COLD: { icon: Snowflake, className: 'text-sky-400' },
};

export function TemperatureBadge({ temperature }) {
  const { t } = useTranslation();
  if (!temperature || !TEMPERATURE_CONFIG[temperature]) {
    return <span className="text-zinc-600 text-sm">—</span>;
  }
  const { icon: Icon, className } = TEMPERATURE_CONFIG[temperature];

  return (
    <span className={`inline-flex items-center gap-1 text-sm ${className}`} title={t(`aiLeadScanner.temperature.${temperature}`)}>
      <Icon className="w-3.5 h-3.5" />
    </span>
  );
}
